/**
 * Обертка слотовой сцены
 * @param {SlotScene} slotScent - готовая слотовая сцена
 * @param {Barrel} barrel - барабан
 * @param {Barrel} freeGamesBarrel - барабан беслатных игр
 * */

import { TYPE, canGo } from "./network/network_api";

export default function SlotView (
    slotScene,
    barrel,
    parent,
    $ticker,
)
{
    // slotScene.setBarrel(barrel);
    
    const space = parent.child( "slot" , 'slot game related streams');
    
    space.s( "initial" )
        .description('initial state of slot scene, actual line billets should be shown')
        .subscribe( ({ lines, multiplier }) => slotScene.onDefaultState && slotScene.onDefaultState( lines, multiplier ) );
    
    space.s( "spinStart" )
        .description('spin is initiated, playing spin sounds')
        .subscribe( p => slotScene.startSpin && slotScene.startSpin( p ) );
    //barrel completely stops (last reel stops):
    space.s( "spinStop" )
        .description('barrel has been completely stopped, muting spin sounds')
        .subscribe( p => slotScene.barrelDidStop && slotScene.barrelDidStop( p ) )
    
    space.s( "reelStop" )
        .description('reel has been stopped, playing bumping sound')
        .subscribe( reel => slotScene.reelStopHandler && slotScene.reelStopHandler(reel, false) );
    
    const $winFlowUp = space.s( "winFlowUp" );
    
    space.s( "winFlowComplete" )
        .description('win flow has been completed')
        .withLatestFrom(parent.s('state'), (interrupt, state) => ({interrupt: interrupt, state: state}))
        .subscribe( ({interrupt, state}) => slotScene.winFlowComplete && slotScene.winFlowComplete(interrupt, (state.type == TYPE.REGULAR && canGo( TYPE.FINAL, state ) )) );
    
    space.s( "linesChange" )
        .description( 'lines has been changed; may to play sound and display them' )
        .subscribe( linesChange => slotScene.linesDidChange && slotScene.linesDidChange( linesChange[ 1 ], linesChange[ 0 ] ) );
    
    space.s( "multiplierChange" )
        .description('multiplier has been changed, should to play sound and describe multiplier value')
        .subscribe( multiplierChange => slotScene.multiplierDidChange && slotScene.multiplierDidChange( multiplierChange[ 1 ], multiplierChange[ 0 ] ) );
    
    $ticker.subscribe(dt => {
        slotScene.update && slotScene.update(dt);
    });
    
    // сюда передать сложный обект в котором и math будет и win
    // math отдастся в сцену
    // win занекстится
    space.s( "showWin")
        .description('initiates win show')
        .subscribe(info => {
        slotScene.showWin && slotScene.showWin(info);
        $winFlowUp.next(info.win * info.bet.multiplier);
    });

    const $showWinComplete = space.s( "showWinComplete" )
        .description('win display completed');

    
    const $showPreFeatureWin = space.s( "showPreFeatureWin" );
    $showPreFeatureWin
        .description('initiates only win flow before extra games (bonus or freegames)')
        .subscribe(info => {
        $winFlowUp.next(info.win * info.bet.multiplier);
    });
    
    $showPreFeatureWin.filter( s => s.bonus ).to( space.s( "showPreBonusWin" ) );
    $showPreFeatureWin.filter( s => !s.bonus ).to( space.s( "showPreFreegamesWin" ) );
    
    space.s( "showPreBonusWin" )
        .description('initiates win show before bonus')
        .subscribe(info => {
        slotScene.showWinBeforeBonus && slotScene.showWinBeforeBonus(info, () => {$showWinComplete.next();});
    });
    
    space.s( "showPreFreegamesWin" )
        .description('initiates win show before freegames')
        .subscribe(info => {
        slotScene.showWinBeforeFreeGames && slotScene.showWinBeforeFreeGames(info, () => {$showWinComplete.next();});
    });
    
    space.s( "interruptWinShow" )
        .description('interrupts win show')
        .subscribe(() => {
        slotScene.interruptShowWin && slotScene.interruptShowWin();
    });
    
    const $forbidStop = space.s( "forbidStop" )
        .description( 'disables STOP button when true' )
    slotScene.forbidStop = () => $forbidStop.next( true )

    space.s( "playingClockSound", false )
        .description('play sound clock tick')
        .withLatestFrom(parent.s('state'), (p, state) => p && (state.type == TYPE.REGULAR || state.type == TYPE.FINISH))
        .on(play => {
            if (play) {
                slotScene.playClockSound && slotScene.playClockSound();
            }
            else {
                slotScene.stopClockSound && slotScene.stopClockSound();
            }
        });

    slotScene.$clockStream = space.s( "playingClockSound" );
    space.s( "interruptWinShow" ).map(() => false).to(space.s( "playingClockSound" ));
    
    return  {
        slotScene,
        space,
    }
}




// WEBPACK FOOTER //
// ./src/library/slot_view.es6